module.exports = __webpack_public_path__ + "img/newPaintingPav10m.9198f3ea.png";